import { CreateContestModule } from '@/modules/fantasy/create-contest';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/fantasy/create-contest/')({
  component: CreateContestPage,
});

function CreateContestPage() {
  return <CreateContestModule />;
}
